/**
 * Feature flags for the MyBed configurator.
 *
 * MYB-121 basket configuration is now **always enabled** — for every visitor,
 * on every page. The previous opt-in toggles have been removed:
 *
 *   - the `?basket=1` / `?basket=0` URL param and the `mybed.basketFeature`
 *     localStorage value are no longer read or written;
 *   - the `window.MYB_FEATURES = { basketConfiguration }` runtime override /
 *     kill-switch is no longer consulted.
 *
 * `isFeatureEnabled()` is kept as the single flag abstraction so call sites stay
 * unchanged and a switch can be reintroduced later if needed.
 */

export const FEATURE_BASKET_CONFIGURATION = 'basketConfiguration';

export function isFeatureEnabled(name = FEATURE_BASKET_CONFIGURATION) {
    return name === FEATURE_BASKET_CONFIGURATION;
}
